import React from "react";
import CheckboxComponent from "@material-ui/core/Checkbox";
import styled, { withTheme } from "styled-components";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { IndeterminateCheckBox } from "@material-ui/icons";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import themes from "../theme";

const style = createMuiTheme({
  palette: {
    primary: {
      main: themes.palette.SECONDARY
    }
  },
  typography: {
    useNextVariants: true
  }
});

const CheckboxComp = ({ theme, ...rest }) => {
  return (
    <MuiThemeProvider theme={style}>
      <CheckboxComponent
        color="primary"
        icon={<CheckBoxOutlineBlankIcon fontSize="default" />}
        checkedIcon={<CheckBoxIcon fontSize="default" />}
        indeterminateIcon={
          <IndeterminateCheckBox color="primary" fontSize="default" />
        }
        {...rest}
      />
    </MuiThemeProvider>
  );
};

CheckboxComp.propTypes = {
  theme: PropTypes.shape({})
};

CheckboxComp.defaultProps = {
  theme: {}
};

export const Checkbox = styled(withTheme(CheckboxComp))``;
